<script lang="ts">
  import { push } from 'svelte-spa-router';
  import { loginUser } from '../../../../components/auth/LoginUser';
  import RepositoryFactory, { CONTRACT } from '../../../../repositories/RepositoryFactory';
  import { format } from 'date-fns';

  export let baseInfoItem!: any;
  export let notesItem!: any;
  export let contactItem!: any;
  export let handleComfirmCloseEvent!: any;
  export let handleCompleteCloseEvent!: any;

  const handleComfirmClose = () => {
    handleComfirmCloseEvent();
  };

  const errorProcess = (error: any) => {
    if (error.response.status === 403) {
      alert('セッションが切れました。再度ログインしてください。');
      loginUser.logout();
      push('/login');
    } else {
      alert('エラーが発生しました。');
    }
  };

  $: getContentsEntered = () => {
    let result = `・解約する回線契約：${baseInfoItem.contractName}
・違約金：${baseInfoItem.penaltyAmount}円
・キャンペーン違約金：${baseInfoItem.campaignPenaltyAmount}円
・工事費残債：${baseInfoItem.remainingConstructionCost}円
・解約する電話契約：${baseInfoItem.contractTelName ?? ''}
・対象電話番号：${baseInfoItem.contractTelNo ?? ''}
・解約日：${baseInfoItem.terminateDate}

・解約にあたり同意いただいた事項
`;
    if (notesItem.notesPenaltyFlg) {
      result += '　・違約金について\n';
    }
    if (notesItem.notesCampaignPenaltyFlg) {
      result += '　・キャンペーン違約金について\n';
    }
    if (notesItem.notesRemainingConstructionCostFlg) {
      result += '　・工事費残債について\n';
    }
    if (notesItem.notesEquipmentRemovalWorkFlg) {
      result += '　・設備の撤去工事について\n';
    }
    if (notesItem.notesReturnOfLineModemFlg) {
      result += '　・回線モデムの返却について\n';
    }
    if (notesItem.notesWithdrawalOfTelFlg) {
      result += '　・いえの電話の解約について\n';
    }
    if (notesItem.notesWithdrawalOfGateCallFlg) {
      result += '　・GateCall(F) / GateCall(M) の解約について\n';
    }
    if (notesItem.notesMailAddressFlg) {
      result += '　・メールアドレスの取り扱い\n';
    }

    if (notesItem.notesEquipmentRemovalWorkItem) {
      result += `
・回線設備の撤去工事
　・撤去工事希望日1：${notesItem.notesEquipmentRemovalWorkItem.constructionHopeDate1}
　・撤去工事希望日2：${notesItem.notesEquipmentRemovalWorkItem.constructionHopeDate2}
　・撤去工事希望日3：${notesItem.notesEquipmentRemovalWorkItem.constructionHopeDate3}
　・ご対応者様 氏名：${notesItem.notesEquipmentRemovalWorkItem.respondentName}
　・ご対応者様 連絡先電話番号：${notesItem.notesEquipmentRemovalWorkItem.respondentTelNo}
`;
    }

    result += `
・連絡先
　・電話番号：${contactItem.contactTelNo}
　・メールアドレス：${contactItem.contactMailAddress ?? '-'}`;

    return result;
  };

  const handleTransitionComplete = () => {
    const terminateDate = format(new Date(baseInfoItem.terminateDate), 'yyyyMMdd');

    const repository = RepositoryFactory[CONTRACT];
    repository
      .terminateHikari01Contract({
        terminateDate: terminateDate,
        terminateTypeCode: 'APPLIED',
        terminateReasonCode: 'OTHER',
        terminateReasonDetail: 'マイページからの申出解約',
        terminateContentsEntered: getContentsEntered(),
        constructionHopeDate1: notesItem.notesEquipmentRemovalWorkItem?.constructionHopeDate1,
        constructionHopeDate2: notesItem.notesEquipmentRemovalWorkItem?.constructionHopeDate2,
        constructionHopeDate3: notesItem.notesEquipmentRemovalWorkItem?.constructionHopeDate3,
        respondentName: notesItem.notesEquipmentRemovalWorkItem?.respondentName,
        respondentTelNo: notesItem.notesEquipmentRemovalWorkItem?.respondentTelNo
      })
      .then((response) => {
        pageStatus = 'COMPLETE';
      })
      .catch((error) => errorProcess(error));
  };
  const handleCompleteClose = () => {
    handleCompleteCloseEvent();
  };

  let pageStatus: 'CONFIRM' | 'COMPLETE' = 'CONFIRM';
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">解約の手続き</h1>
    </div>
  </div>
  {#if pageStatus === 'CONFIRM'}
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex-1 m-10">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <div class="mb:font-sm w-full">
            <p>以下の内容で解約手続きを進めます。問題なければ実行ボタンを押下ください。</p>

            <!-- 解約にあたり同意いただいた事項 基本情報-->
            <ul class="list-disc mt-4 ml-4">
              <li>
                <p>解約する回線契約：{baseInfoItem.contractName}</p>
              </li>
              <li>
                <p>違約金：{baseInfoItem.penaltyAmount}円</p>
              </li>
              <li>
                <p>
                  キャンペーン違約金：{baseInfoItem.campaignPenaltyAmount}円
                </p>
              </li>
              <li>
                <p>工事費残債：{baseInfoItem.remainingConstructionCost}円</p>
              </li>
              <li>
                <p>解約する電話契約：{baseInfoItem.contractTelName ?? ''}</p>
              </li>
              <li>
                <p>対象電話番号：{baseInfoItem.contractTelNo ?? ''}</p>
              </li>
              <li>
                <p>解約日：{baseInfoItem.terminateDate}</p>
              </li>
            </ul>

            <!-- 解約にあたり同意いただいた事項 -->
            <ul class="list-disc mt-6 ml-4">
              <li>
                <p>解約にあたり同意いただいた事項</p>
              </li>
              {#if notesItem.notesPenaltyFlg}
                <li class="ml-4">
                  <p>違約金について</p>
                </li>
              {/if}
              {#if notesItem.notesCampaignPenaltyFlg}
                <li class="ml-4">
                  <p>キャンペーン違約金について</p>
                </li>
              {/if}
              {#if notesItem.notesRemainingConstructionCostFlg}
                <li class="ml-4">
                  <p>工事費残債について</p>
                </li>
              {/if}
              {#if notesItem.notesEquipmentRemovalWorkFlg}
                <li class="ml-4">
                  <p>設備の撤去工事について</p>
                </li>
              {/if}
              {#if notesItem.notesReturnOfLineModemFlg}
                <li class="ml-4">
                  <p>回線モデムの返却について</p>
                </li>
              {/if}
              {#if notesItem.notesWithdrawalOfTelFlg}
                <li class="ml-4">
                  <p>いえの電話の解約について</p>
                </li>
              {/if}
              {#if notesItem.notesWithdrawalOfGateCallFlg}
                <li class="ml-4">
                  <p>GateCall(F) / GateCall(M) の解約について</p>
                </li>
              {/if}
              {#if notesItem.notesMailAddressFlg}
                <li class="ml-4">
                  <p>メールアドレスの取り扱い</p>
                </li>
              {/if}
            </ul>

            <!-- 回線設備の撤去工事 -->
            {#if notesItem.notesEquipmentRemovalWorkItem}
              <ul class="list-disc mt-6 ml-4">
                <li>
                  <p>回線設備の撤去工事</p>
                </li>
                <li class="ml-4">
                  <p>
                    撤去工事希望日1：{notesItem.notesEquipmentRemovalWorkItem.constructionHopeDate1}
                  </p>
                </li>
                <li class="ml-4">
                  <p>
                    撤去工事希望日2：{notesItem.notesEquipmentRemovalWorkItem.constructionHopeDate2}
                  </p>
                </li>
                <li class="ml-4">
                  <p>
                    撤去工事希望日3：{notesItem.notesEquipmentRemovalWorkItem.constructionHopeDate3}
                  </p>
                </li>
                <li class="ml-4">
                  <p>
                    ご対応者様 氏名：{notesItem.notesEquipmentRemovalWorkItem.respondentName}
                  </p>
                </li>
                <li class="ml-4">
                  <p>
                    ご対応者様 連絡先電話番号：{notesItem.notesEquipmentRemovalWorkItem.respondentTelNo}
                  </p>
                </li>
              </ul>
            {/if}

            <!-- 連絡先 -->
            <ul class="list-disc mt-6 ml-4">
              <li>
                <p>連絡先</p>
              </li>
              <li class="ml-4">
                <p>電話番号：{contactItem.contactTelNo}</p>
              </li>
              {#if contactItem.contactMailAddress}
                <li class="ml-4">
                  <p>メールアドレス：{contactItem.contactMailAddress}</p>
                </li>
              {/if}
            </ul>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-items-center items-center p-2">
        <p><span class="warning">お手続き実行後の取り消しはできません</span></p>
      </div>

      <div class="flex flex-col justify-items-center items-center">
        <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
          <button class="button-secondary md:ml-5 mb-5" on:click|once={handleComfirmClose}> 戻る </button>
          <button class="button-primary md:ml-5 mb-5" on:click|once={handleTransitionComplete}> 実行 </button>
        </div>
      </div>
    </div>
  {:else if pageStatus === 'COMPLETE'}
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex-1 m-10">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <div class="mb:font-sm w-full">
            <ul class="list-none mt-4">
              <li>
                <p>解約依頼を受け付けました</p>
              </li>
              <li class="mt-2">
                <p>お手続きについてご不明な点がございましたら、以下からご連絡いただくようお願いいたします。</p>
              </li>
              <li>
                <p>URL：https://bb01.unext.co.jp/contact</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="flex flex-col justify-items-center items-center">
        <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
          <button class="button-secondary md:ml-5 mb-5" on:click|once={handleCompleteClose}> 契約内容へ </button>
        </div>
      </div>
    </div>
  {/if}
</div>

<style lang="postcss">
  p {
    @apply tracking-normal mb-1;
  }
  p > span.warning {
    @apply font-semibold text-red-400;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-14 py-2;
  }
  .button-secondary {
    @apply bg-gray-300 rounded hover:bg-gray-400 text-sm font-semibold text-gray-500 focus:outline-none px-14 py-2;
  }
</style>
